import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './RadioButton.module.scss';

const RadioButton = ({ value, checked, disabled, children, onChange, classes }) => (
  <div className={styles.radio}>
    <label htmlFor={`id-${value}`}>
      <input
        id={`id-${value}`}
        type="radio"
        value={value}
        checked={checked}
        onChange={(e) => onChange(value, e)}
        disabled={disabled}
      />
      <span className={cx(styles.radioLabel, classes.label, disabled && styles.radioLabelDisabled)}>{children}</span>
    </label>
  </div>
);

RadioButton.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
  checked: PropTypes.bool,
  children: PropTypes.node,
  onChange: PropTypes.func,
  classes: PropTypes.shape({
    label: PropTypes.string,
  }),
};

RadioButton.defaultProps = {
  checked: false,
  children: null,
  classes: {},
  onChange: () => {},
};

export default RadioButton;
